import { BeanPrimaryEntity } from "../../bean-primary-entity";
export class UnitsLTSA extends BeanPrimaryEntity {
    unitLtsaId: number;
    unitId: number;
    ltsaStatusId: string | null;

    unitLtsaTypeId: string | null;
    serviceContractorId: number | null;
    hasLtsa: number | null;

    contractLength: string;
    preferredContractor: string;
    contractExpiration: string;
    contractExpirationResolution: string | null;
    author: number | null;
    comments: string;

    constructor(entity?: any) {
        super(entity);
        this.unitLtsaId = entity?.unitLtsaId ?? null;
        this.unitId = entity?.unitId ?? null;
        this.ltsaStatusId = entity?.ltsaStatusId ?? null;
        this.unitLtsaTypeId = entity?.unitLtsaTypeId ?? null;
        this.serviceContractorId = entity?.serviceContractorId ?? null;
        this.hasLtsa = entity?.hasLtsa ?? null;
        this.contractLength = entity?.contractLength ?? '';
        this.contractExpiration = entity?.contractExpiration ?? '';
        this.contractExpirationResolution = entity?.contractExpirationResolution ?? null;
        this.preferredContractor = entity?.preferredContractor ?? '';
        this.comments = entity?.comments ?? '';
        this.author = entity?.author ?? null;
    }


}

